<app-header />
<app-cookie-bar />
<div class="main">
    <router-outlet />
</div>
<app-footer />
